import type { IconSvgObject } from './types';

const BlurIcon: IconSvgObject = [
  ["path", { d: "M12.5926 2.21C12.2371 1.93 11.7433 1.93 11.3877 2.21C9.51122 3.66 3.97049 8.39 4.00012 13.9C4.00012 18.36 7.58531 22 12.0001 22C16.4149 22 20 18.37 20 13.91C20.0099 8.48 14.4593 3.67 12.5926 2.21Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 2V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 19L20 15M12 14.1806L19 10.5M12 9.36145L16.5727 7", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BlurIcon;
